import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ForceConnectComponent, VideoComponent} from './video/video.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {HttpService} from './http.service';
import {HttpClientModule} from '@angular/common/http';
import {ClearComponent, PermissionsComponent} from './permissions/permissions.component';
import {FineComponent} from './fine/fine.component';
// import * as Sentry from '@sentry/angular';
// import {Router} from '@angular/router';
import {MatStepperModule} from '@angular/material/stepper';
import {MatButtonModule} from '@angular/material/button';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faCamera, faCheck, faChevronLeft, faChevronRight, faCog, faLock, faMicrophone, faSpinner, faUnlock, faVideo, faVolumeUp} from '@fortawesome/free-solid-svg-icons';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ThemeService} from './theme.service';
import {MatSelectModule} from '@angular/material/select';
import {MatMenuModule} from '@angular/material/menu';
import {MatDialogModule} from '@angular/material/dialog';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";

@NgModule({
    declarations: [
        AppComponent,
        VideoComponent,
        NotFoundComponent,
        PermissionsComponent,
        FineComponent,
        ForceConnectComponent,
        ClearComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        MatStepperModule,
        MatButtonModule,
        FontAwesomeModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatMenuModule,
        MatDialogModule,
        MatProgressSpinnerModule
    ],
    providers: [
        HttpService,
        ThemeService,
        // {
        //     provide: ErrorHandler,
        //     useValue: Sentry.createErrorHandler({
        //         showDialog: false,
        //     }),
        // },
        // {
        //     provide: Sentry.TraceService,
        //     deps: [Router],
        // },
        // {
        //     provide: APP_INITIALIZER,
        //     useFactory: () => () => {
        //     },
        //     deps: [Sentry.TraceService],
        //     multi: true,
        // },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(library: FaIconLibrary) {
        library.addIcons(faVideo);
        library.addIcons(faUnlock);
        library.addIcons(faLock);
        library.addIcons(faCheck);
        library.addIcons(faMicrophone);
        library.addIcons(faCamera);
        library.addIcons(faSpinner);
        library.addIcons(faChevronRight);
        library.addIcons(faChevronLeft);
        library.addIcons(faVolumeUp);
        library.addIcons(faCog);
    }
}
